module.exports = __webpack_public_path__ + "residualPerformanceSummary.f441508f24b65c36c81f3e34aff61d5a.png";